import { frontendURL } from 'dashboard/helper/URLHelper'

const InsuranceReminders = () => import('./InsuranceReminders.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/insurance'),
      name: 'insurance_reminders',
      meta: {
        permissions: ['administrator'],
      },
      component: InsuranceReminders,
    },
  ],
};
